import {
  DigestRecommendationsPayload,
  isDigestRecommendationsSuccessPayload,
} from '../shared-types'
import { RecommendationsState } from './types'

import { defineStore } from 'pinia'

import { SfLog } from '@app/adapters/logger'
import { useCommon } from './common'
import { showErrorBanner } from '@app/application/account-mapping/utils'

export const useRecommendations = defineStore('accountMappingRecommendations', {
  state: (): RecommendationsState => ({
    isWaitingForRecommendations: false,
    recommendationError: '',
  }),
  actions: {
    autoMapRecommendations() {
      const commonStore = useCommon()

      Object.values(commonStore.$state.recommendations).forEach(
        ({ id, proposals }) => {
          commonStore.addAccountToGroupFromRecommendations({
            accountRange: proposals[0],
            accountId: id,
          })
        }
      )
    },
    async digestRecommendations(data: DigestRecommendationsPayload) {
      const commonStore = useCommon()

      if (isDigestRecommendationsSuccessPayload(data)) {
        commonStore.receiveRecommendations(data)

        if (!commonStore.$state.isFetching) {
          this.autoMapRecommendations()
        }
      } else {
        showErrorBanner(data.error_message, data.error_messages_per_locale)

        await commonStore.fetchInitialData({
          externalMappingsAvailable: false,
          isAiMappingProposalSupported: false,
          shouldUsePostfixes: commonStore.$state.shouldUsePostfixes,
        })

        SfLog.info('Failed receiving account mapping recommendations', {
          extra: {
            error: data.error_message,
          },
        })
      }

      this.stopWaitingForRecommendations()
    },
    startWaitingForRecommendations() {
      this.isWaitingForRecommendations = true
    },
    stopWaitingForRecommendations() {
      this.isWaitingForRecommendations = false
    },
  },
})
